import { styled } from "@mui/material/styles";

export const StyledLink = styled("a")(() => ({
  overflow: "hidden",
  textOverflow: "ellipsis"
}))